import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CustomerListCards = ({ customers, onViewDetails, onEdit, onDelete, selectedIds, onSelectRow }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  };

  return (
    <div className="grid grid-cols-1 gap-4">
      {customers?.map((customer) => (
        <div
          key={customer?.id}
          className={`bg-card border rounded-xl p-4 hover:shadow-md transition-shadow cursor-pointer ${
            selectedIds?.has(customer?.id) ? 'border-accent/40 bg-accent/5' : 'border-border'
          }`}
          onClick={() => onViewDetails(customer)}
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center gap-3 min-w-0 flex-1">
              <div
                className="flex-shrink-0"
                onClick={e => { e?.stopPropagation(); onSelectRow?.(customer?.id); }}
              >
                <input
                  type="checkbox"
                  checked={selectedIds?.has(customer?.id) || false}
                  onChange={() => {}}
                  className="rounded border-border text-accent focus:ring-accent cursor-pointer"
                />
              </div>
              <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Building2" size={24} className="text-accent" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-base font-semibold text-foreground truncate capitalize">
                  {customer?.companyName}
                </h3>
                <p className="text-sm text-muted-foreground truncate capitalize">{customer?.contactPerson}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0 ml-2">
              <Button
                variant="ghost"
                size="icon"
                onClick={(e) => {
                  e?.stopPropagation();
                  onEdit(customer);
                }}
                className="hover:bg-accent/10 hover:text-accent"
              >
                <Icon name="Pencil" size={16} />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={(e) => {
                  e?.stopPropagation();
                  onDelete(customer);
                }}
                className="hover:bg-destructive/10 hover:text-destructive"
              >
                <Icon name="Trash2" size={16} />
              </Button>
            </div>
          </div>

          <div className="space-y-2 mb-3">
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Mail" size={14} className="text-muted-foreground flex-shrink-0" />
              <span className="text-muted-foreground truncate">{customer?.email}</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Phone" size={14} className="text-muted-foreground flex-shrink-0" />
              <span className="text-muted-foreground">{customer?.phone}</span>
            </div>
          </div>

          <div className="flex items-center justify-between pt-3 border-t border-border">
            <div className="flex items-center gap-2">
              <Icon name="Briefcase" size={16} className="text-accent" />
              <span className="text-sm font-medium text-foreground">
                {customer?.activeProjects} Active Projects
              </span>
            </div>
            <div className="text-right">
              <p className="text-xs text-muted-foreground">Total Value</p>
              <p className="text-base font-semibold text-accent">
                {formatCurrency(customer?.totalValue)}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomerListCards;